import React from 'react';
import PropTypes from 'prop-types';

import './ReviewRating.css';

const MAX_RATING = 5;

export default function ReviewRating({ rating }) {
    const normalizedRating = Math.max(0, Math.min(MAX_RATING, Math.round(rating || 0)));

    return (
        <span className="ReviewRating" aria-label={`별점 ${normalizedRating}점`}>
            {Array.from({ length: MAX_RATING }).map((_, index) => (
                <span
                    className={`ReviewRating-star ${index < normalizedRating ? 'ReviewRating-star--filled' : ''}`}
                    key={index}
                    aria-hidden="true"
                >
                    ★
                </span>
            ))}
        </span>
    );
}
ReviewRating.propTypes = {
    rating: PropTypes.number
};
